module.exports = __webpack_public_path__ + "ecomondo_news-cover.jpg?01d274b29377c100f8ea38e4634daf5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecomondo_news-cover.jpg
// module id = 179
// module chunks = 0